import { BaseService } from './base'
import { APIPath } from 'utility/constant'
import { CommonUtility } from 'utility/common'

class Report {
    getReport(queryParams) {
        const { ShowExecutiveReport, ...rest } = queryParams || {}
        const params = CommonUtility.objectToParams(rest)
        if (ShowExecutiveReport === undefined || ShowExecutiveReport === null) {
            return BaseService.get(`${APIPath.report}?${params}`)
        }
        const lastParam = `ShowExecutiveReport=${ShowExecutiveReport}`
        const qs = params ? `${params}&${lastParam}` : lastParam
        return BaseService.get(`${APIPath.report}?${qs}`)
    }

    addCustomeReport(data) {
        return BaseService.post(`${APIPath.customeReport}`, data)
    }

    getCheckInReport(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.checkInReport}?${params}`)
    }

    getCheckInUserReport(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.checkInReport}?${params}`)
    }

    getCumulativeReport(data) {
        return BaseService.post(APIPath.cumulativeReport, {
            ReportId: 3, // Hardcoded as per requirement
            CompanyId: data.CompanyId,
            UserIds: data.UserIds, // CompanyId is already the company_id from the customer data
            TaskStartDate: data.StartDate.split('+')[0], // Remove timezone offset
            TaskEndDate: data.EndDate.split('+')[0],
            StatusList: data.StatusList,
            CustomerIds: data.CustomerIds, // Remove timezone offset
        })
    }

    getCustomReportTypes() {
        return BaseService.get(APIPath.getCustomReportTypes)
    }

    getCombineTemplateReport(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.combineTemplateReport}?${params}`)
    }

    getCustomDashboardType1(queryParams) {
        const params = CommonUtility.objectToParams(queryParams)
        return BaseService.get(`${APIPath.customDashboardType1}?${params}`)
    }

    getCombineTemplateReportPost(data) {
        return BaseService.post(APIPath.report, data)
    }

    getInspectionReportCumulative(auditIds) {
        const params = CommonUtility.objectToParams({ AuditIds: auditIds })
        return BaseService.get(`${APIPath.inspectionReportCumulative}?${params}`)
    }

    sendEmailDueTemplateReminder(data) {
        return BaseService.postExact(APIPath.emailDueTemplateReminder, data)
    }

    getAuditorSummary(data) {
        return BaseService.postExact(APIPath.auditorSummary, data)
    }

    getProcessHealthOptions() {
        return BaseService.get(APIPath.processHealthOptions)
    }

    getProcessHealthReport(data) {
        return BaseService.postExact(APIPath.processHealth, data)
    }
}

const ReportService = new Report()
Object.freeze(ReportService)
export { ReportService }
